import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { formatTime } from '../../lib/utils'

interface TimerOverlayProps {
  elapsed: number
  isActive: boolean
}

export function TimerOverlay({ elapsed, isActive }: TimerOverlayProps) {
  const [displayTime, setDisplayTime] = useState(elapsed)

  useEffect(() => {
    if (!isActive) {
      setDisplayTime(elapsed)
      return
    }

    const interval = setInterval(() => {
      setDisplayTime((prev) => prev + 10)
    }, 10)

    return () => clearInterval(interval)
  }, [isActive, elapsed])

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <motion.div
          animate={{ textShadow: '0 0 30px rgba(0, 217, 165, 0.8)' }}
          transition={{ duration: 1, repeat: Infinity, repeatType: 'reverse' }}
          className="text-9xl font-fredoka font-700 text-tropical-green"
        >
          {formatTime(displayTime)}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-2xl font-fredoka font-600 text-sand-light mt-4"
        >
          {isActive ? 'RACE ACTIVE' : 'PAUSED'}
        </motion.div>
      </motion.div>
    </div>
  )
}
